import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import MenuItem from "../../../helpers/MenuItem/MenuItem";
import GetMetaButton from "../../../helpers/GetMetaButton/GetMetaButton";
import { sliderProps } from "../../../utils";
import { base_url } from "../../../services/configServices/config";

const HomePublic = () => {
  const image = useSelector((state) => state.meta?.image);
  const papularMenu = useSelector((state) => state.meta?.popularMenu);
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <>
      <SiteTitle title="صفحه اصلی" />

      {/* Section Started Slider */}
      <section className="section kf-started-slider">
        <Swiper
          className="swiper-container"
          {...sliderProps.mainSliderSelector}
        >
          <SwiperSlide className="swiper-slide">
            <div className="kf-started-item align-center">
              <div
                className="slide"
                style={{
                  backgroundImage: `url(${base_url + image?.homeBanner})`,
                }}
              />
              <div className="container">
                <div className="description align-right element-anim-1">
                  <div className="subtitles">به {setting?.title} خوش آمدید</div>
                  <h2 className="name text-anim-1">
                    {setting?.title} بندرعباس
                  </h2>
                  <div className="kf-bts">
                    <div
                      className="kf-filter kf-filter-menu element-anim-1 scroll-animate"
                      data-animate="active"
                      id="menu"
                    >
                      <div className="row align-items-center py-3">
                        <div className="col-6 col-sm-5 col-md-4 col-lg-3">
                          <Link to="/menu" className="active w-100 fs-5">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 24 24"
                            >
                              <g fill="currentColor">
                                <path d="M8.016 6.982a1.003 1.003 0 0 0 0 2.006h7.95a1.003 1.003 0 0 0 0-2.006zm-1 5.018c0-.552.447-1.003 1-1.003h7.95a1.003 1.003 0 0 1 0 2.006h-7.95c-.553 0-1-.45-1-1.003m1.009 3.012a1.003 1.003 0 0 0 0 2.007h7.95a1.003 1.003 0 0 0 0-2.007z" />
                                <path
                                  fill-rule="evenodd"
                                  d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
                                  clip-rule="evenodd"
                                />
                              </g>
                            </svg>
                            <hr className="border-white" />
                            <span className="d-block">منو کافه</span>
                          </Link>
                        </div>
                        <div className="col-6 col-sm-5 col-md-4 col-lg-3">
                          <a
                            href={`tel:${setting?.phoneNumber}`}
                            className="w-100 fs-5"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 24 24"
                            >
                              <g fill="currentColor">
                                <path d="M22 12A10 10 0 0 0 12 2v2a8 8 0 0 1 7.391 4.938A8 8 0 0 1 20 12zM2 10V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a8 8 0 0 0 8 8v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5C7.373 22 2 16.627 2 10" />
                                <path d="M17.543 9.704A6 6 0 0 1 18 12h-1.8A4.2 4.2 0 0 0 12 7.8V6a6 6 0 0 1 5.543 3.704" />
                              </g>
                            </svg>
                            <hr className="border-white" />
                            <span className="d-block">تماس با مجموعه</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <div className="mainSlider-prev swiper-button-prev" />
          <div className="mainSlider-next swiper-button-next" />
        </Swiper>
      </section>
      {/* Section About */}
      <section className="section kf-about section-bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
              <div className="kf-titles">
                <div
                  className="kf-subtitle element-anim-1 scroll-animate"
                  data-animate="active"
                >
                  کافه {setting?.title}
                </div>
                <h3
                  className="kf-title element-anim-1 scroll-animate"
                  data-animate="active"
                >
                  به {setting?.title} خوش آمدید
                </h3>
              </div>
              <div
                className="kf-text element-anim-1 scroll-animate"
                data-animate="active"
              >
                <p>
                  ممنون که {setting?.title} رو انتخاب کردید. امیدواریم این چند
                  لحظه ای که در کنار هم هستیم یکی از بهترین لحظه های خوب
                  زندگیتون باشه
                </p>
                <ul className="p-0">
                  <p className="text-white font-weight-bold">
                    پیشاپیش از اینکه این موضوع رو درک می کنید کلی ممنونیم
                  </p>
                  <li>
                    تو روزهای خیلی شلوغ ساعت حضور برای هر میز 1:15 الی 1:30 هست
                  </li>
                  <li>
                    اگر خواستید بیشتر پیشمون باشید هزینه رزرو به ازای هر ساعت
                    بهتون اعلام میشه
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7">
              <div
                className="kf-about-image element-anim-1 scroll-animate"
                data-animate="active"
              >
                <img src="/assets/images/about_img.png" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Services */}
      <section className="section kf-services section-bg">
        <div className="container">
          <div className="kf-services-items row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <Link to="/menu">
                    <img src="/assets/images/service1.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-utensils" />
                  </div>
                  <h5 className="name">فست فود</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <Link to="/menu">
                    <img src="/assets/images/service2.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-coffee" />
                  </div>
                  <h5 className="name">صبحانه</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <Link to="/menu">
                    <img src="/assets/images/service3.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-glass-cheers" />
                  </div>
                  <h5 className="name">نوشیدنی</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Menu */}
      <section
        className="section kf-menu kf-parallax"
        style={{ backgroundImage: "url(/assets/images/category_bg.jpg)" }}
      >
        <div className="container">
          <div className="kf-titles align-center">
            <div
              className="kf-subtitle element-anim-1 scroll-animate"
              data-animate="active"
            >
              بهترین ها حق شماست
            </div>
            <h3
              className="kf-title element-anim-1 scroll-animate"
              data-animate="active"
            >
              محبوب ترین های {setting?.title}
            </h3>
          </div>
          <div
            className="kf-menu-items"
            style={{ backgroundImage: "url(/assets/images/menu_logo.png)" }}
          >
            {isEmpty(papularMenu) ? (
              <GetMetaButton />
            ) : (
              <div className="row justify-content-center">
                {papularMenu?.map((item) => (
                  <MenuItem key={item._id} data={item} />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Section Grid Carousel */}
      <section className="section kf-grid-carousel">
        <div className="container">
          <Swiper {...sliderProps.kfGridCarousel} className="swiper-container">
            {image?.homeCarousel?.map((_item, index) => (
              <SwiperSlide className="swiper-slide" key={index}>
                <div
                  className="slide-item element-anim-1 scroll-animate"
                  data-animate="active"
                >
                  <div className="image kf-image-hover">
                    <img src={base_url + _item} alt={setting?.title} />
                  </div>
                  <div className="desc">
                    <h5 className="name">{setting?.title}</h5>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* Section Numbers */}
      <section className="section kf-numbers">
        <div className="container">
          <div className="kf-numbers-items row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div className="kf-numbers-item">
                <div className="num">15+</div>
                <div className="desc">
                  <h5 className="name">تنوع غذایی</h5>
                  <div className="subname">فست فود و صبحانه</div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div className="kf-numbers-item">
                <div className="num">27+</div>
                <div className="desc">
                  <h5 className="name">تنوع نوشیدنی</h5>
                  <div className="subname">نوشیدنی های سرد و گرم</div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div className="kf-numbers-item">
                <div className="num">22+</div>
                <div className="desc">
                  <h5 className="name">تنوع پیش غذا</h5>
                  <div className="subname">سالاد و دسر به همراه کیک</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePublic;
